import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome"
import { tailwindPalette } from "../../../../theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    wrap: {
        width: "100%",
        borderRadius: "0.25rem",
        overflow: "hidden",
    },
    image: {
        width: "100%",
        height: "auto",
        aspectRatio: "4/3",
        objectFit: "cover",
    },
    placeholder: {
        width: "100%",
        height: "100%",
        padding: "1rem",
        aspectRatio: "4/3",
        color: tailwindPalette.slate[400],
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: tailwindPalette.slate[200],
    },
}))

type ProductImgProps = Readonly<{
    imageUri?: string
    icon: FontAwesomeIconProps["icon"]
    alt?: string
}>

export function CardImage({ imageUri, icon, alt }: ProductImgProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.wrap}>
            {!Boolean(imageUri) ? (
                <Box className={classes.placeholder}>
                    <FontAwesomeIcon size="2x" icon={icon} />
                </Box>
            ) : (
                <img alt={alt} src={imageUri} className={classes.image} />
            )}
        </Box>
    )
}
